import app from 'app';

import ready from 'utils/ready';
import lightbox from './product/lightbox';
import linkedProducts from './product/linked-products';
import linkedProductsBySku from './product/linked-products-by-sku';
import media from './product/media';
import product from './product/main';
import recommendations from './product/recommendations';
import complementaryForm from './product/complementary-form';
import swatches from './product/swatches';

app.add({
  'product-complementary-form': complementaryForm,
  'product-lightbox': lightbox,
  linkedProducts,
  'linked-products-by-sku': linkedProductsBySku,
  'product-media': media,
  product,
  'product-recommendations': recommendations,
  'product-swatches': swatches,
});

ready(app.mount);
